export const datosProyectos = [
  {
    owner: "Ezequielpereyraa",
    repo: "MarvellComics-Challenge",
    description:
      "Challenge consumiendo la API de Marvell, de las cuales se muestra en forma de tarjetas los Heroes, se puede presionar el nombre o la imagen para ver su descripcion si es que lo tiene.",
    language: "SCSS",
    stars: "1",
    forks: 0,
    homepage: "https://ep-marvelcomicschallenge.netlify.app/",
    link: "https://github.com/Ezequielpereyraa/MarvellComics-Challenge",
  },
  {
    owner: "Ezequielpereyraa",
    repo: "buscador-imagenes",
    description:
      "Buscador de imagenes, consumiendo API de Pixabay, esta app te permite poder buscar imagenes y poder descargar las imagenes en alta calidad",
    language: "JavaScript",
    stars: "2",
    forks: 0,
    homepage: "https://ep-buscadorimagenes.netlify.app/",
    link: "https://github.com/Ezequielpereyraa/buscador-imagenes",
  },
  {
    owner: "Ezequielpereyraa",
    repo: "Cooperativa-independencia",
    description: "Sitio web para Cooperativa Independencia",
    language: "HTML",
    stars: 0,
    forks: 0,
    homepage: "http://independencialda.com.ar/",
    link: "https://github.com/Ezequielpereyraa/Cooperativa-independencia",
  },
  {
    owner: "Ezequielpereyraa",
    repo: "Natours",
    description:
      "Sitio web realizado con metodologi­a BEM, buenas practicas con SASS, y esta maquetado con la propiedad Float",
    language: "CSS",
    stars: 0,
    forks: 0,
    homepage: "https://ep-natours.netlify.app/",
    link: "https://github.com/Ezequielpereyraa/Natours",
  },
  {
    owner: "Ezequielpereyraa",
    repo: "cotizador-criptomonedas-react",
    description: "Cotizador de Criptomonedas",
    language: "JavaScript",
    stars: 0,
    forks: 0,
    homepage: "https://ep-cotizadorcriptomonedas.netlify.app/",
    link: "https://github.com/Ezequielpereyraa/cotizador-criptomonedas-react",
  },
  {
    owner: "Ezequielpereyraa",
    repo: "Presupuesto-App",
    description: "Proyecto para calcular gastos semanales",
    language: "JavaScript",
    stars: "1",
    forks: 0,
    homepage: "https://ep-presupuestoapp.netlify.app/",
    link: "https://github.com/Ezequielpereyraa/Presupuesto-App",
  },
];
